// /book-a-demo: the booking calendar as a page, for old links, emails and
// "open in new tab". Every other "Book a demo" opens it over the page.
import React from "react";
import SEO from "../SEO";
import BookingFlow from "./BookingFlow";

export default function BookingPage() {
  return (
    <main className="page container bk-page">
      <SEO
        title="BossDrop | Book a demo"
        description="Book a 20-minute BossDrop demo with the founder. Pick a time that works for you and get a Google Meet invite."
        canonical="https://bossdrop.ai/book-a-demo"
        url="https://bossdrop.ai/book-a-demo"
      />
      <div className="bk-sheet bk-sheet-page">
        <BookingFlow />
      </div>
    </main>
  );
}
